//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      steps: ['输入邀请码'],
      message: '输入邀请码',
      steps1: ['点击关联管理人', '输入邀请码'],
      message1: '点击关联管理人',
      showindicators: false,
      loopenable: false
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    onChange: function (index) {
      this.currentStep = '0' + (Number(index) + 1)
      this.message = this.steps[Number(index)]
    },
    leftClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2))
    },
    rightClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep))
    },
    onChange1: function (index) {
      this.currentStep1 = '0' + (Number(index) + 1)
      this.message1 = this.steps1[Number(index)]
    },
    leftClick1: function (event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1 - 2))
    },
    rightClick1: function (event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/inviteGuide.vue